// extracted by mini-css-extract-plugin
module.exports = {"labeled-input":"labeled-input___3nelB","bolded":"bolded___1q8B8","label-box":"label-box___1APj-","is-transparent":"is-transparent___3pPli"};